module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', [_c('p', {
    staticClass: "ORIM-Chapter-Title-Page-Break--Body-",
    attrs: {
      "id": "_idParaDest-1"
    }
  }, [_c('a', {
    attrs: {
      "id": "_idTextAnchor000"
    }
  }), _c('b', [_vm._v("PRAISE FOR THE WRITING "), _c('br'), _vm._v("OF MIKE CAREY, LINDA CAREY, AND LOUISE CAREY")])]), _vm._v(" "), _c('p', {
    staticClass: "Chapter-Opener ParaOverride-1"
  }, [_c('em', {
    staticClass: "italic"
  }, [_c('b', [_vm._v("The Steel Seraglio")])])]), _vm._v(" "), _c('p', {
    staticClass: "Chapter-Opener"
  }, [_vm._v("“The Careys nest smaller tales within the larger story and often jump around in time; it’s a good approach, backed by fast pacing and great characters. . . . ["), _c('em', {
    staticClass: "italic"
  }, [_vm._v("The Steel Seraglio")]), _vm._v(" is] a thrilling tale.” —"), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Publishers Weekly")])]), _vm._v(" "), _c('p', {
    staticClass: "Chapter-Opener"
  }, [_vm._v("“With remarkable elegance, the Careys have enriched meta-fictional allegory into furious pop entertainment—full of sex, passion, violence, and magic. "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("The Steel Seraglio")]), _vm._v(" is razor-sharp, cutting straight through the bullshit of bigotry to tell a fun, resonant story.” —"), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Slant")])]), _vm._v(" "), _c('p', {
    staticClass: "Chapter-Opener"
  }, [_vm._v("“"), _c('em', {
    staticClass: "italic"
  }, [_vm._v("The Steel Seraglio")]), _vm._v(" is not a work of feminist or utopian theory. Nor is it a historical fantasy, a romance, a thriller, a poem, an allegory, or an epic. Rather, somehow, it is all of these things, mixed with a handful of gnomic utterances, a generous splash of the comic, and permeated by a deep understanding of what it means to weave a fairytale through with vision, to tell stories as a way of making meaning and making change, and to let those stories hang and fall. . . .” —"), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Neon")])]), _vm._v(" "), _c('p', {
    staticClass: "Chapter-Opener"
  }, [_vm._v("“"), _c('em', {
    staticClass: "italic"
  }, [_vm._v("The Steel Seraglio")]), _vm._v(" is a masterful, engaging and utterly fascinating story by three wonderful writers. One can only hope they will collaborate again, as this project has proven how well they work together. The reader is really the winner here.” —SFRevu.com")]), _vm._v(" "), _c('p', {
    staticClass: "Chapter-Opener ParaOverride-1"
  }, [_c('em', {
    staticClass: "italic"
  }, [_c('b', [_vm._v("The House of War and Witness")])])]), _vm._v(" "), _c('p', {
    staticClass: "Chapter-Opener"
  }, [_vm._v("“["), _c('em', {
    staticClass: "italic"
  }, [_vm._v("The House of War and Witness")]), _vm._v("] is a fantastical ghost story and a suspenseful military mystery. . . . A daringly original fantasy novel.” —"), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Publishers Weekly")]), _vm._v(", starred review")]), _vm._v(" "), _c('p', {
    staticClass: "Chapter-Opener _idGenParaOverride-1"
  }, [_vm._v("“The Careys have a talent for characterization: all of the characters come alive on the pages—even the ghosts. . . . ["), _c('em', {
    staticClass: "italic"
  }, [_vm._v("The House of War and Witness")]), _vm._v("] is a compelling, accomplished novel, deft with its characters and interesting with its themes.” —"), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Strange Horizons")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2b6c0034","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/HouseWarWitness-2.vue
// module id = 66
// module chunks = 0